import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { EmailHistoryReportFilterParams } from '~bank-reports/types/EmailHistoryReport'

export const emailHistoryReportQueryOptions = (deps: Partial<EmailHistoryReportFilterParams>) =>
  queryOptions({
    queryKey: ['emailHistoryReport', deps],
    queryFn: () => Request.post(Request.urls.bank.portalReportEmailHistory, { ...deps }),
    structuralSharing: true,
    staleTime: 1000,
    placeholderData: keepPreviousData
  })
